import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { useNavigate } from "react-router-dom";

function HeroCarousel({ items = [] }) {
  const navigate = useNavigate();

  // ✅ Use ONLY items with backdrop images
  const heroItems = items.filter(
    (item) => item.backdrop_path
  );

  if (!heroItems.length) return null;

  return (
    <div className="hero-carousel">
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation
        loop
      >
        {heroItems.map((item) => {
          const imageUrl = `https://image.tmdb.org/t/p/original${item.backdrop_path}`;

          return (
            <SwiperSlide key={item.id}>
              <div
                className="hero-slide"
                style={{
                  backgroundImage: `url(${imageUrl})`,
                }}
                onClick={() => navigate(`/details/${item.id}`)}
              >
                <div className="hero-overlay">
                  <h1>{item.title}</h1>

                  <p className="hero-subtitle">
                    🔥 Trending on WatchItNow
                  </p>

                  <button className="hero-btn">Watch</button>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default HeroCarousel;
